<template>
  <v-container class="pt-0" style="background-color: white" fluid>
    <v-row no-gutters justify="center">
      <v-col cols="12" md="6" justify="center" align="center">
        <span style="font-size: 30px; color: #616161">
          <v-icon large class="pr-1 pb-2">mdi-account-file-text-outline</v-icon>
          Provisiones de nomina</span>
      </v-col>
    </v-row>
    <v-card flat class="pt-3">
      <v-data-table :headers="headers" :items="provisions_computed" :search="search"  height="55vh" loading-text="Cargando datos..." dense fixed-header :items-per-page="60">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Provisiones</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            {{ provisions_computed.length }}
            <v-spacer> </v-spacer>
            <v-text-field class="mt-3" dense label="Buscar.." v-model="search" append-icon="search" single-line
              hide-details outlined></v-text-field>
            <v-spacer></v-spacer>
            <v-btn outlined dense color="success" @click="add_provision()">Nueva</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" medium color="blue" @click="edit_provision(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pt-10">
            <v-icon size="80px">token</v-icon>
          </v-row>
          <v-row justify="center" class="pb-6"> No hay datos </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog_edit" width="40%">
      <v-card flat>
        <v-card-title>
          <span class="headline">{{ is_edit ? 'Editar' : 'Nueva' }} provision</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="(dialog_edit = false)">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-card class="pt-3" flat>
              <v-row justify="center" align="center">
                <v-col :cols="provision.entry_type_id?'6':'12'" justify="center" align="center">
                  <v-autocomplete v-model="provision.entry_type_id" :items="[{ value: 1, text: 'Devengo' }, { value: 2, text: 'Deduccion' }]"
                    label="Tipo" outlined dense hide-details></v-autocomplete>
                </v-col>
                <v-col cols="6" align="end">
                  <v-autocomplete v-show="provision.entry_type_id === 1" v-model="provision.accrual_id" :items="accruals" item-text="description_long" item-value="id"
                    label="Devengo" outlined dense hide-details></v-autocomplete>

                  <v-autocomplete v-show="provision.entry_type_id === 2" v-model="provision.deduction_id" :items="deductions" item-text="description_long" item-value="id"
                    label="Deduccion" outlined dense hide-details></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" align="center">
                  <v-autocomplete v-model="provision.currency_id" :items="currencies" item-text="description" item-value="id"
                    label="Moneda" outlined dense hide-details></v-autocomplete>
                </v-col>
                <v-col cols="6" align="center">
                  <v-text-field v-model="provision.employee_contribution" type="number"
                    label="Contribucion del empleado" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" align="center">
                  <v-text-field v-model="provision.company_contribution" type="number"
                    label="Contribucion del empleador" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="6" align="center">
                  <v-text-field v-model="provision.amount_top" type="number"
                    label="Tope maximo" outlined dense hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" align="center">
                  <v-autocomplete v-model="provision.debit_chart_of_account_id" :items="accounts" item-text="name" item-value="id"
                    label="Cuenta debito" outlined dense hide-details></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" align="center">
                  <v-autocomplete v-model="provision.credit_chart_of_account_id" :items="accounts" item-text="name" item-value="id"
                    label="Cuenta credito" outlined dense hide-details></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="(dialog_edit = false)">
            Cancelar
          </v-btn>
          <v-btn text color="success" @click="save_provision()">{{ is_edit ? 'Actualizar' : 'Guardar' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
export default {
  data: () => ({
    search: null,
    dialog_edit: false,
    is_edit: false,
    provision: {
      id: null,
      debit_chart_of_account_id: null,
      credit_chart_of_account_id: null,
      entry_type_id: null,
      employee_contribution: 0,
      company_contribution: 0,
      amount_top: 0,
      currency_id: null,
    },
    currencies:[],
    accruals:[],
    deductions:[],
    accounts: [],
    provisions: [],
    headers: [
      { text: "Descripcion", value: "description" },
      { text: "Moneda", value: "currency_code" },
      { text: "Tipo", value: "accrual_or_deduction" },
      { text: "Fecha efectiva", value: "effective_date_formated" },
      { text: "Contribución compañía", value: "company_contribution",align:"end" },
      { text: "Contribución empleado", value: "employee_contribution",align:"end" },
      { text: "Debito", value: "account_debit" },
      { text: "Credito", value: "account_credit" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  computed: {
    provisions_computed() {
        let provisions =[];
        for(let item of this.provisions){
          item.description=item.is_deduction?`${item.deduction} (${item.deduction_short})`:`${item.accrual} (${item.accrual_short})`;
          item.accrual_or_deduction=item.is_deduction?'Deduccion':'Devengo';
          item.effective_date_formated=moment(item.effective_date).format('DD/MM/YYYY');  
          provisions.push(item);
        }
        return provisions;
    },
  },
  mounted() {
    this.initialized();
  },
  // watch: {},
  methods: {
    async initialized() {
      this.get_provisions();
      //CUENTAS
      const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.accounts.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
      //DEVENGOS
      const result = await this.api_Get("humanResource/accruals");
      const data = await result.json();
      this.accruals = data;
      //DEDUCCIONES
      const resultDeductions = await this.api_Get("humanResource/deductions");
      const dataDeductions = await resultDeductions.json();
      this.deductions = dataDeductions;
      //MONEDAS
      const resultCurrencies = await this.api_Get("accounting/currencies");
      this.currencies = await resultCurrencies.json();
    },
    async get_provisions() {
      const request = await this.api_Get("accounting/get_provisions");
      this.provisions = await request.json();
    },
    edit_provision(provision) {
      this.provision = Object.assign({}, provision);
      this.is_edit = true;
      this.dialog_edit = true;
    },
    add_provision() {
      this.provision.id = null;
      this.provision.debit_chart_of_account_id = null;
      this.provision.credit_chart_of_account_id = null;
      this.provision.entry_type_id = null;
      this.provision.currency_id = null;
      this.provision.amount_top = 0;
      this.provision.company_contribution = 0;
      this.provision.employee_contribution = 0;
      this.provision.accrual_id = null;
      this.provision.deduction_id = null;
      this.is_edit = false;
      this.dialog_edit = true;
    },
    async save_provision() {
      if (this.provision.debit_chart_of_account_id == null) {
        this.$toast.warning('Debe seleccionar la cuenta de debito');
        return
      }
      if (this.provision.credit_chart_of_account_id == null) {
        this.$toast.warning('Debe seleccionar la cuenta de credito');
        return
      }
      if (this.provision.entry_type_id == null) {
        this.$toast.warning('Debe seleccionar el tipo');
        return
      }
      if (this.provision.entry_type_id == 1 && this.provision.accrual_id == null) {
        this.$toast.warning('Debe seleccionar un devengo');
        return
      }
      if (this.provision.entry_type_id == 2 && this.provision.deduction_id == null) {
        this.$toast.warning('Debe seleccionar una deduccion');
        return
      }
      if (this.provision.currency_id == null) {
        this.$toast.warning('Debe seleccionar la moneda');
        return
      }
      try {
        this.provision.effective_date = moment().format('YYYY-MM-DD');
        this.provision.is_deduction = this.provision.entry_type_id == 2;
         const result = await this.api_Post('accounting/add_or_update_payroll_provisions', this.provision);
        if (result.status == 200) {
          this.$toast.success(`Provision ${this.is_edit ? 'actualizada' : 'registrada'} correctamente!`);
          this.dialog_edit = false;
        }
        this.get_provisions();
      } catch (error) {
        this.$toast.error(error.message);
        console.error(error.message);
      }
    }
  },
};
</script>